import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import * as Yup from 'yup'
import { useSelector } from 'react-redux'
import { ImagePdfBucket } from '../../../CommonUtils/ImagesBase64'
import { viewImage } from '../../../CommonUtils/viewImage'
import { ERROR_MSG } from '../../../CommonUtils/contextVariables'
import { failureAlert } from '../../../CommonUtils/SweetAlerts'
import { UseGetStatus } from '../../../CommonUtils/Commonstatus'
import Swal from 'sweetalert2'

function AddressChange() {
    const coursesFlags = useSelector((state) => state?.commonMastersReducer?.coursesFlags);
    const validations = Yup.object().shape({
        isChangeaddress: Yup.string().required(ERROR_MSG).nullable(),
        addressPdf: Yup.string().when('isChangeaddress', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string(),
        }),
    })
    const formik = useFormik({
        initialValues: {
            isChangeaddress: '',
            addressPdf: ''
        },
        validationSchema: validations,
        onSubmit: (val) => {
            if (val.isChangeaddress === 'false') {
                val.addressPdf = '';
            }
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: true, // This will block background interaction
                allowOutsideClick: false, // Prevents closing by clicking outside
                allowEscapeKey: false
            }).then((result) => {
                if (result.isConfirmed) {

                    let url = config.url.API_URL + `saveChangeAddress`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                            }).then((refresh) => {
                                if (refresh.isConfirmed) {
                                    GetData();
                                    UseGetStatus();
                                }
                            })
                        }
                        else {
                            failureAlert('Failed to Submit')
                        }
                    })
                }
            })
        }
    })
    const [getaddrchangedata, setaddrchnagedata] = useState('');
    function GetData() {
        formik?.setFieldValue('isChangeaddress', coursesFlags?.is_change_colg_addr != null ? coursesFlags?.is_change_colg_addr?.toString() : '');
        formik?.setFieldValue('isChangeaddress', coursesFlags?.is_change_colg_addr?.toString())
        let url = config.url.API_URL + `getChangeAddress`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setaddrchnagedata(res?.data?.getChangeAddress)
                formik?.setFieldValue("addressPdf", res?.data?.getChangeAddress ?? '')
            }
        })
    }

    useEffect(() => {
        GetData()
    }, [coursesFlags])
    return (
        <>
            <FormikProvider value={formik}>
                <Form onChange={formik?.handleChange} onSubmit={formik?.handleSubmit} className='affl-form'>
                    <h5>7. College Application for Change of Address of College</h5>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className='form-control'>
                        <label htmlFor="isChangeaddress" className='me-2'>
                            Is college applying for any change of address of the college :
                        </label>
                        <div style={{ marginBottom: '10px' }}>
                            <Field as="select" name="isChangeaddress" className="form-control mt-2" style={{ width: 'auto' }}
                                // onChange={() => formik?.setFieldValue("addressPdf", '')}
                                onChange={(e) => {
                                    // formik.setFieldValue("isChangeaddress", e.target.value);
                                    if (!getaddrchangedata) {
                                        formik.setFieldValue("addressPdf", '');
                                    }
                                }}>
                                <option value="">--SELECT--</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </Field>
                            <ErrorMessage name="isChangeaddress" component="div" className="text-error" />
                        </div>


                    </div>
                    {formik?.values?.isChangeaddress === 'true' && (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3%' }}>
                            <label htmlFor="addressPdf" style={{ marginRight: '10px' }}>
                                Please upload the Permission proceedings of Competent Authority:
                            </label>
                            <div style={{ marginBottom: '10px' }}>
                                <input
                                    type="file" accept="application/pdf"
                                    name="addressPdf"
                                    className="form-control mt-2"
                                    style={{ width: 'auto' }}
                                    onChange={(e) => {
                                        let filename = `addressPdf`;
                                        let path = "/Uploads/AffiliationPDFs/2023/";
                                        ImagePdfBucket(e, formik, path, `addressPdf`, filename, "pdf");
                                    }}
                                />
                                <ErrorMessage name="addressPdf" component="div" className="text-error" />

                                {getaddrchangedata ? (<><button type="button" className="text-primary" onClick={() => { viewImage(getaddrchangedata) }}>View</button></>) : (<></>)}

                            </div>
                        </div>
                    )}
                    <button type="submit" className="btn btn-success btn-sm float-end mt-3  mx-3">Submit</button>

                    <pre /> <pre /> <pre />
                </Form>
            </FormikProvider>
        </>
    )
}

export default AddressChange
